import { css } from '@emotion/react';
import { useDeepMemo } from '@vitvio/helpers';
import type {
  StyleGroup,
  ColorProps,
  FontProps,
  PaddingProps,
  MarginProps,
  TextDecorationProps,
  BackgroundColorsProps,
  DimensionProps,
  PositioningProps,
  DisplayFlexProps,
  LayoutProps,
  OverflowProps,
  FlexProps,
  BoxMiscProps,
} from './styleResolvers';
import { useTheme } from '../../provider/useTheme';
import { STYLE_RESOLVERS } from './styleResolvers';

/** Props accepted by useStylesCss: text styles (CoreText) and box styles (CoreBox). */
type UseStylesCssProps = Partial<
  ColorProps &
    FontProps &
    PaddingProps &
    MarginProps &
    TextDecorationProps &
    DimensionProps &
    PositioningProps &
    DisplayFlexProps &
    LayoutProps &
    OverflowProps &
    FlexProps &
    BackgroundColorsProps &
    BoxMiscProps
>;

export const useStylesCss = (props: UseStylesCssProps, styles: readonly StyleGroup[]) => {
  const theme = useTheme();

  return useDeepMemo(() => {
    const parts = styles.flatMap((group) => {
      const fn = STYLE_RESOLVERS[group];
      return fn ? fn(props as Record<string, unknown>, theme) : [];
    });
    return css(parts);
  }, [props, theme]);
};
